import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = {
  class: "c-data"
};
var _hoisted_2 = ["src"];
var _hoisted_3 = {
  class: "c-data-title"
};
var _hoisted_4 = {
  class: "c-data-footer"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("img", {
    class: "c-data-icon",
    src: $data.images[$props.type],
    alt: ""
  }, null, 8, _hoisted_2), _createElementVNode("h4", _hoisted_3, [_renderSlot(_ctx.$slots, "title", {}, function () {
    return [_createTextVNode(_toDisplayString($props.title), 1)];
  })]), _createElementVNode("div", _hoisted_4, [_renderSlot(_ctx.$slots, "footer")])]);
}